import Acrade from "../assets/images/icon-arcade.svg"
import Advanced from "../assets/images/icon-advanced.svg"
import Pro from "../assets/images/icon-pro.svg"

const plansData = [
    {
        icon: Acrade,
        plan: "Acrade",
        monthly: 9,
        yearly: 90,
        num: 0

    },
    {
        icon: Advanced,
        plan: "Advanced",
        monthly: 12,
        yearly: 120,
        num: 1

    },
    {
        icon: Pro,
        plan: "Pro",
        monthly: 15,
        yearly: 150,
        num: 2

    }
]

export default plansData